import React, { useState, useContext, useEffect, useRef } from 'react';
import { SocketContext } from '../components/SocketContext';
import ScrollableFeed from 'react-scrollable-feed'
import TextField from '@mui/material/TextField';
import SoundManager from '../components/SoundManager';
import Settings from '../helpers/Settings';

const maxInputLength = Settings.chatMaxInputLength;

const ChatAndGuess = () => {
    const socket = useContext(SocketContext);
    const [messages, setMessages] = useState([]);
    const [currentMessage, setCurrentMessage] = useState('');
    const chatWindowRef = useRef(null);

    function findAndScrollTextarea() {
        console.log('findAndScrollTextarea');
        const chatViewSpans = document.querySelector('span.chatview');
    
        //chatViewSpans.forEach(span => {
          //const parent = span.parentNode;
          const textareas = chatViewSpans.querySelector('textarea');
          
          if (textareas) {
            //const firstTextarea = textareas[0];
            textareas.scrollTop = textareas.scrollHeight;
            return;
          }
        //});
      }
    
      // Call the function to find and scroll to the textarea
      setTimeout(findAndScrollTextarea, 0);

    //const chatWindowRef = React.createRef();
    useEffect(() => {
        socket.on('chatmsg', (data) => {
            //console.log('chatmsg: ' + data.message);
            SoundManager.playNewMessageSound();
            handleShowChatMessage(data.message);
        });
    

        return () => {
            socket.off('chatmsg');
        };
    }, []);

    function handleInputChange(e) {
        let message = e.target.value;
        if (message.length > maxInputLength) {
          message = message.substring(0, maxInputLength);
          e.target.value = message;
        }
        setCurrentMessage(e.target.value);
      }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent the default action (form submission)
            SoundManager.playSentMessageSound();
            handleSendMessage(e.target.value);
            e.target.value = '';
        }
    };

    const handleShowChatMessage = (message) => {
        setMessages((prevMessages) => [...prevMessages, message]);
    }

    const handleSendMessage = (message) => {
        const trimmedMessage = currentMessage.trim();
        if (trimmedMessage != null && trimmedMessage !== '') {
            setMessages((prevMessages) => [...prevMessages, message]);
            setCurrentMessage('');
            socket.emit('chatmsg', { message: message });
        }
    };

    
    return (
        <div>
            <span className="chatview">
            <TextField
                label="Chat"
                multiline
                rows={14}
                variant="outlined"
                value={messages.join('\n')}
                fullWidth
                InputProps={{
                    readOnly: true,
                }}
            />
            </span>
            <br />

            <span className="chatinput">
                <TextField
                    label="Message"
                    variant="outlined"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    fullWidth
                    autoComplete='off'
                    maxLength='100'
                />
            </span>
        </div>
    );
};

export default ChatAndGuess;